import React from 'react';
import { Modal } from 'antd';
import * as translations from './strings';
import { getLangKey } from '../../../../models/Language';
import { ButtonShape, ButtonType } from 'antd/lib/button';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { ExclamationCircleFilled } from '@ant-design/icons';
import cx from 'classnames';
const strings = translations[getLangKey()];

type Styles = { [key: string]: string };

type Props = {
  container: HTMLDivElement;
  styles: Styles;
  isAdminView?: boolean;
  setConfirmingGuestAssignee?: (value: boolean) => void;
  setCallback?: (resolve: (value: boolean) => void) => void;
  confirmGuest?: ((value: boolean) => void) | null;
  open?: boolean;
};

const content = (styles: Styles) => (
  <span>
    {strings.visibleTo}
    <br />
    <span className={styles.visibleToClients}>{strings.membersAndClients}</span>
  </span>
);

const commonProps = (
  container: HTMLDivElement,
  styles: Styles,
  isAdminView: boolean = true
) => ({
  title: !isAdminView ? (
    <>
      <ExclamationCircleFilled className={styles.confirmIcon} />
      {strings.assignTaskToClient}
    </>
  ) : (
    strings.assignTaskToClient
  ),
  okText: strings.assignToClient,
  cancelText: strings.cancel,
  okButtonProps: {
    type: 'primary' as ButtonType,
    size: 'middle' as SizeType,
    'data-cypress-trigger': 'assignGuestConfirmationModalOkButton'
  },
  cancelButtonProps: {
    type: 'default' as ButtonType,
    className: styles.cancel,
    size: 'middle' as SizeType,
    shape: 'round' as ButtonShape,
    'data-cypress-trigger': 'assignGuestConfirmationModalCancelButton'
  },
  wrapClassName: cx(styles.assignToClientModal, {
    [styles.normalModal]: !isAdminView
  }),
  autoFocusButton: null,
  centered: true,
  maskClosable: true,
  getContainer: () => container
});

export const confirmGuestAssignee = ({
  container,
  styles,
  isAdminView,
  setCallback,
  setConfirmingGuestAssignee
}: Props): Promise<boolean> =>
  new Promise(resolve => {
    if (!isAdminView && setCallback && setConfirmingGuestAssignee) {
      setCallback((value: boolean) => {
        resolve(value);
        setConfirmingGuestAssignee?.(false);
      });
      setConfirmingGuestAssignee(true);
      return;
    }
    setConfirmingGuestAssignee?.(true);
    Modal.confirm({
      onOk: () => {
        resolve(true);
        setConfirmingGuestAssignee?.(false);
      },
      onCancel: () => {
        resolve(false);
        setConfirmingGuestAssignee?.(false);
      },
      content: content(styles),
      ...commonProps(container, styles)
    });
  });

export const AssignedGuestConfirmationModal = ({
  container,
  styles,
  open,
  confirmGuest
}: Props) => {
  if (!confirmGuest) return null;

  return (
    <Modal
      open={open}
      width={416}
      onOk={() => confirmGuest(true)}
      onCancel={() => confirmGuest(false)}
      data-cypress-trigger="assignGuestConfirmationModal"
      {...commonProps(container, styles, false)}
    >
      {content(styles)}
    </Modal>
  );
};
